import React from 'react';
import AssetRelianceFooter from "../../../ClientManagement/AssetReliance/AssetRelianceFooter";
import AssetRelianceSummaryContent from "./AssetRelianceSummaryContent";
import AssetRelianceHeader from "../../../ClientManagement/AssetReliance/AssetRelianceHeader";
import {selectClientAssets} from "../../../Assets/clientAssetsSlice";
import {FveDiscountRateType} from "../../../ClientManagement/AssetReliance/AssetRelianceButtonState";
import {useAppSelector} from "../../../store/hooks";
import {AssetsSummary} from "../../../Assets/models/Assets";
import PrintViewWrapper from "../PrintViewWrapper";
import {selectAssetRelianceReportResponse} from "./AssetRelianceReportSlice";

type assetRelianceSummaryReportProps = {
    showExpectedExcessAsset?: boolean,
    includeLifeInsuranceAtDeath?: boolean,
    selectedFveDiscountRate?: FveDiscountRateType
    displayName: string,
    profileId: string
}

const AssetRelianceSummaryReport = ({showExpectedExcessAsset = false, includeLifeInsuranceAtDeath = false, selectedFveDiscountRate = FveDiscountRateType.TRIPLE_NET, displayName, profileId}: assetRelianceSummaryReportProps) => {
    const assetResponse = useAppSelector(selectAssetRelianceReportResponse);
    const assetRelianceButtonState =  {
        showExpectedExcessAsset: showExpectedExcessAsset,
        includeLifeInsuranceAtDeath: includeLifeInsuranceAtDeath,
        selectedFveDiscountRate: selectedFveDiscountRate
    }

    const accountHasAssets = !!assetResponse.allAssetsStack.netAssets || !!assetResponse.goals.totalPresentValue;
    const clientAssets: AssetsSummary | undefined = useAppSelector(selectClientAssets);

    return (
        <PrintViewWrapper displayName={displayName}>
        <div className="asset-reliance">
            <AssetRelianceHeader
                id={profileId}
                title="Review Asset Reliance"
                headerOptions={assetRelianceButtonState}
                investorGroup={assetResponse.investorGroupResponse}
                showPageActionMenu={false}
                lifeInsurances={clientAssets?.lifeInsurances}
            />
            <>
                <AssetRelianceSummaryContent
                    goalsSummaryDTO={assetResponse.goals}
                    allAssetsStack={assetResponse.allAssetsStack}
                    assetStacks={assetResponse.assetStacks}
                    excludedAssetStacks={assetResponse.excludedAssetStacks}
                    id={profileId}
                    accountHasAssets={accountHasAssets}
                    investorGroup={assetResponse.investorGroupResponse}
                    showExpectedExcessAsset={showExpectedExcessAsset}
                    includeLifeInsuranceAtDeath={includeLifeInsuranceAtDeath}
                    selectedFveDiscountRate={selectedFveDiscountRate}
                />
            </>
            <AssetRelianceFooter/>
        </div>
        </PrintViewWrapper>
    )
}

export default AssetRelianceSummaryReport;